import { Link } from 'react-router-dom';
import JsonLd from './JsonLd';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface Props {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: Props) {
  return (
    <nav style={{
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
      flexWrap: 'wrap',
      fontFamily: "'DM Sans', sans-serif",
      fontSize: '0.7rem',
      fontWeight: 600,
      letterSpacing: '0.06em',
      textTransform: 'uppercase',
      color: 'rgba(255,255,255,0.5)',
      marginBottom: '0.75rem',
    }}>
      {items.map((item, i) => (
        <span key={i} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          {i > 0 && (
            <span style={{ color: 'rgba(138,149,168,0.35)', fontSize: '0.8rem' }}>/</span>
          )}
          {item.href ? (
            <Link
              to={item.href}
              style={{ color: 'rgba(255,255,255,0.5)', textDecoration: 'none', transition: 'color 0.2s' }}
              onMouseEnter={(e) => (e.currentTarget.style.color = '#B8860B')}
              onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(255,255,255,0.5)')}
            >
              {item.label}
            </Link>
          ) : (
            <span style={{ color: '#B8860B' }}>{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}

export function BreadcrumbJsonLd({ items }: { items: Array<{ label: string; href: string }> }) {
  return (
    <JsonLd data={{
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": items.map((item, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "name": item.label,
        "item": "https://apexholdings.com" + item.href,
      })),
    }} />
  );
}
